import React from "react";
import { PRIORITY_STYLES, SLA_STYLES, SLA_LABELS } from "../lib/format";

const base = "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold tracking-wide whitespace-nowrap";

export function StatusBadge({ status, statusMeta }) {
  return (
    <span data-testid={`status-badge-${status}`} className={`${base} border border-border`} style={statusMeta?.color ? { backgroundColor: `${statusMeta.color}20`, color: statusMeta.color, borderColor: statusMeta.color } : undefined}>
      {statusMeta?.label || status}
    </span>
  );
}

export function PriorityBadge({ priority }) {
  return (
    <span data-testid={`priority-badge-${priority}`} className={`${base} ${PRIORITY_STYLES[priority] || PRIORITY_STYLES.LOW}`}>
      {priority}
    </span>
  );
}

export function SlaBadge({ status }) {
  return (
    <span data-testid={`sla-badge-${status}`} className={`${base} ${SLA_STYLES[status] || SLA_STYLES.NOT_STARTED}`}>
      {SLA_LABELS[status] || status}
    </span>
  );
}
